import { useRef } from 'react';
import { useIntersectionObserver } from '../../../hooks/useIntersectionObserver';

export default function MidCTA() {
  const ref = useRef<HTMLDivElement>(null);
  const visible = useIntersectionObserver(ref, { threshold: 0.3 });

  return (
    <section className="relative py-20 overflow-hidden bg-forest-600">
      {/* Subtle texture */}
      <div className="absolute inset-0 opacity-10">
        <img
          src="https://public.readdy.ai/ai/img_res/8d79534ca3136e2b3ac74ea4bf5b2590.jpg"
          alt=""
          className="w-full h-full object-cover"
        />
      </div>
      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-stone-400/30 to-transparent" />
      <div className="absolute bottom-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-stone-400/30 to-transparent" />

      <div
        ref={ref}
        className={`relative z-10 max-w-7xl mx-auto px-8 flex flex-col md:flex-row items-center justify-between gap-8 transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
      >
        <div className="text-center md:text-left">
          <p className="font-sans text-stone-300 text-xs tracking-[0.2em] uppercase mb-2">Limited Consultation Slots Available</p>
          <h3 className="font-serif text-white text-3xl md:text-4xl font-semibold leading-tight">
            Ready to Start Your<br />
            <em className="italic text-stone-300">Outdoor Transformation?</em>
          </h3>
        </div>
        <div className="flex flex-col sm:flex-row items-center gap-4 flex-shrink-0">
          <a
            href="tel:5756358883"
            className="inline-flex items-center gap-3 bg-white/10 hover:bg-white/20 border border-white/25 text-white font-sans font-medium text-sm px-7 py-3.5 rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-phone-fill" />
            </div>
            (575) 635-8883
          </a>
          <a
            href="#consultation"
            onClick={(e) => { e.preventDefault(); document.getElementById('consultation')?.scrollIntoView({ behavior: 'smooth' }); }}
            className="inline-flex items-center gap-2 bg-white hover:bg-stone-100 text-forest-700 font-sans font-semibold text-sm px-8 py-3.5 rounded-md transition-all cursor-pointer whitespace-nowrap"
          >
            Request Free Consultation
            <div className="w-4 h-4 flex items-center justify-center">
              <i className="ri-arrow-right-line" />
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}
